module.exports = __webpack_public_path__ + "img/curve_lg.69f96144.svg";